import { flexBuyTermOptions } from './constants';

export const replaceConstantWithTerm = ({ currentTerm, constantLabel }: { constantLabel: string; currentTerm: string }) => {
    return constantLabel.replace(/{currentTerm}/g, currentTerm);
};

export const getCurrentMonth = ({ parseSelectedTermId }: { parseSelectedTermId: number | undefined }): number | undefined => {
    return parseSelectedTermId && flexBuyTermOptions.some((option) => option.id === parseSelectedTermId.toString())
        ? Number(parseSelectedTermId)
        : undefined;
};
